/**
 * Validation error messages for Zod schemas
 * Used for form validation with internationalization support
 */
export const validation = {
  en: {
    validation_required: "Can't be blank",
    validation_invalid_type: 'Expected {{expected}}, received {{received}}',
    validation_invalid_string: 'Invalid string',
    validation_email: 'Invalid email address',
    validation_url: 'Invalid URL',
    validation_min_length: 'Minimum length is {{count}}',
    validation_max_length: 'Maximum length is {{count}}',
    validation_min_value: 'Minimum value is {{count}}',
    validation_max_value: 'Maximum value is {{count}}',
    validation_min_items: 'Must have at least {{count}} items',
    validation_max_items: 'Must have at most {{count}} items',
    validation_too_small: 'Value is too small',
    validation_too_big: 'Value is too big',
    validation_invalid_date: 'Invalid date',
    validation_invalid_enum: 'Invalid value. Must be one of: {{options}}',
    validation_invalid: 'Invalid value',
    validation_passwords_not_match: 'Passwords do not match',
    validation_google_maps_link:
      'Invalid Google Maps link. Example: https://www.google.com/maps/@47.97735,33.4227343,12z',
    validation_card_number_format: 'Card number must be 16 digits',
    validation_select_locations_first: 'Please select locations first',
    validation_code_format:
      'Only lowercase latin letters, digits and underscores',
    validation_max_2_decimals: 'Up to 2 decimal places',
    validation_non_negative_amount: 'Enter 0 or a positive amount',
    validation_positive_integer_or_blank:
      'Enter a whole number greater than 0, or leave it empty',
    validation_positive_integer: 'Enter a whole number greater than 0',
    validation_non_negative_integer: 'Enter 0 or a whole positive number',
    validation_duration_units:
      'Enter a positive multiple of {{count}} minutes for a bookable service',
  },
  uk: {
    validation_required: 'Поле не може бути пустим',
    validation_invalid_type: 'Очікувалось {{expected}}, отримано {{received}}',
    validation_invalid_string: 'Невірний рядок',
    validation_email: 'Невірна адреса електронної пошти',
    validation_url: 'Невірний URL',
    validation_min_length: 'Мінімальна довжина {{count}}',
    validation_max_length: 'Максимальна довжина {{count}}',
    validation_min_value: 'Мінімальне значення {{count}}',
    validation_max_value: 'Максимальне значення {{count}}',
    validation_min_items: 'Повинно містити принаймні {{count}} елементів',
    validation_max_items: 'Повинно містити не більше {{count}} елементів',
    validation_too_small: 'Значення занадто мале',
    validation_too_big: 'Значення занадто велике',
    validation_invalid_date: 'Невірна дата',
    validation_invalid_enum: 'Невірне значення. Має бути одним з: {{options}}',
    validation_invalid: 'Невірне значення',
    validation_passwords_not_match: 'Паролі не співпадають',
    validation_google_maps_link:
      'Невірне посилання Google Maps. Приклад: https://www.google.com/maps/@47.97735,33.4227343,12z',
    validation_card_number_format: 'Номер картки повинен містити 16 цифр',
    validation_select_locations_first: 'Спочатку виберіть локації',
    validation_code_format: 'Лише малі латинські літери, цифри та підкреслення',
    validation_max_2_decimals: 'Не більше 2 знаків після коми',
    validation_non_negative_amount: 'Введіть 0 або додатну суму',
    validation_positive_integer_or_blank:
      'Введіть ціле число більше 0 або залиште порожнім',
    validation_positive_integer: 'Введіть ціле число більше 0',
    validation_non_negative_integer: 'Введіть 0 або ціле додатне число',
    validation_duration_units:
      'Для послуги з бронюванням введіть додатне число, кратне {{count}} хвилинам',
  },
};
